export async function callTogether(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  try {
    const body = {
      model: context.modelOverride || 'meta-llama/Llama-3.2-3B-Instruct-Turbo',
      messages: [
        { 
          role: 'system',
          content: context.systemPrompt || `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}.` 
        },
        { role: 'user', content: input }
      ],
      temperature: 0.2,
      max_tokens: 512
    };

    console.log('[Together] Request:', { 
      endpoint: 'https://api.together.xyz/v1/chat/completions', 
      headers: {
        'Authorization': `Bearer ${apiKey.substring(0, 4)}...`,
        'Content-Type': 'application/json'
      },
      body 
    });

    const cleanKey = apiKey.trim();
    const res = await fetch('https://api.together.xyz/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${cleanKey}`,
        'Content-Type': 'application/json'
      },
      signal,
      body: JSON.stringify(body)
    });
    
    if (!res.ok) {
      let errorMsg = `Together API error: ${res.status}`;
      try {
        const errorData = await res.json();
        errorMsg = errorData.error?.message || errorMsg;
      } catch (e) {
        // Not JSON, ignore
      }
      throw new Error(errorMsg);
    }

    const data = await res.json();
    return data.choices?.[0]?.message?.content || '';
  } catch (error: any) {
    console.error('[Together Provider] Error:', error);
    throw error;
  }
}
